import { CustomerModel } from "@crypto-payment-gateway/models"
import { useQuery } from "@tanstack/react-query"
import { useAuth } from "../context/AuthContext"
import { getCustomers } from "../services/customers"

export function useCustomers() {
	const { user } = useAuth()
	return useQuery<CustomerModel[]>({
		queryKey: ["customers", user.id],
		queryFn: async () => {
			const customersRes = await getCustomers(user.id)
			console.log(customersRes)
			return customersRes || []
		},
	})
}
